// Region selection init
const provinceIDSelector = 'reward_form_submission_submission_data_address_province'; // 1st level
const cityIDSelector = 'reward_form_submission_submission_data_address_city'; // 2nd level
const districtIDSelector = 'reward_form_submission_submission_data_address_district'; // 3rd level
const villageIDSelector = 'reward_form_submission_submission_data_address_village'; // 4th level

const whitelistProvinces = $('#' + provinceIDSelector).attr('data-whitelist-provinces');
const whitelistProvincesArray = whitelistProvinces ? whitelistProvinces.split(',') : [];

loadRegionList(provinceIDSelector, 'ID-62-0-0', false, whitelistProvincesArray);
loadRegionList(cityIDSelector, '', true);
loadRegionList(districtIDSelector, '', true);
loadRegionList(villageIDSelector, '', true);

const $formSelectProvince = $('#' + provinceIDSelector);
$formSelectProvince.on('change', function () {
  let selectedRegionParentID = $formSelectProvince.find('option:selected').val();
  $('#' + cityIDSelector).empty()
  loadRegionList(cityIDSelector, selectedRegionParentID, false);
  $('#' + districtIDSelector).empty()
  loadRegionList(districtIDSelector, '', true);
  $('#' + villageIDSelector).empty()
  loadRegionList(villageIDSelector, '', true);
})

const $formSelectCity = $('#' + cityIDSelector);
$formSelectCity.on('change', function () {
  let selectedRegionParentID = $formSelectCity.find('option:selected').val();
  $('#' + districtIDSelector).empty();
  loadRegionList(districtIDSelector, selectedRegionParentID, false);
  loadRegionList(villageIDSelector, '', true);
})

const $formSelectDistrict = $('#' + districtIDSelector);
$formSelectDistrict.on('change', function () {
  let selectedRegionParentID = $formSelectDistrict.find('option:selected').val();
  $('#' + villageIDSelector).empty();
  loadRegionList(villageIDSelector, selectedRegionParentID, false);
})

function loadRegionList(selectID, parentID, readonly, whitelistProvincesArray = []) {

  if (parentID === "" || parentID === undefined) return

  whitelistProvincesArray = whitelistProvincesArray.map(item => item.toLowerCase());

  path_url = '/api/v1/regions';
  if (window.location.host === 'app.ruangguru.com') {
    path_url = '/form/api/v1/regions';
  } else {
    path_url = '/api/v1/regions';
  }

  const $select2Selector = $('#' + selectID);
  $select2Selector.addClass('region-select');
  $select2Selector.select2({
    theme: 'bootstrap',
    ajax: {
      type: 'get',
      url: '/api/v1/regions?parent_id=' + parentID,
      dataType: 'json',
      data: function (params) {
        return {
          searchTerm: params.term // search term
        };
      },
      delay: 250,
      processResults: function (data) {
        let regionData = data.data;
        if (selectID === villageIDSelector) {
          let others = 'Lainnya';
          regionData.push({
            regionName: others,
            globalID: others
          });
        }
        return {
          results: $.map(regionData, function (item) {
            if (whitelistProvincesArray && whitelistProvincesArray.length > 0) {
              if (whitelistProvincesArray.includes(item.regionName.toLowerCase())) {
                return {
                  text: item.regionName,
                  id: item.globalID
                }
              }
            } else {  
              return {
                text: item.regionName,
                id: item.globalID
              }
            }
          })
        };
      }
    }
  });

  $select2Selector.prop("readonly", readonly);

  const savedValue = Cookies.get(selectID);
  if (savedValue) {
    $.ajax({
      type: 'GET',
      url: '/api/v1/regions?parent_id=' + parentID,
      dataType: 'json'
    }).then(function (response) {
      const regionData = response.data;

      // Try to find the item in the result list
      const match = regionData.find(item => item.globalID == savedValue);

      if (match) {
        option = new Option(match.regionName, match.globalID, true, true)
        $select2Selector.append(option).trigger('change');
      }
    });
  }
}

$('.region-select').each(function() {
  if ($(this).attr('data-dependent-field-visibility') === 'hidden') {
    $(this).next(".select2-container").addClass('d-none');
  }
});
